<template>
  <b-modal v-model="show" size="lg" centered no-close-on-backdrop header-class="bg-modal-header" class="modal-dialog-right">

    <template #modal-header>
      <div class="fw-bold">충전 이력 정보</div>
    </template>

    <div class="row">
      <div class="col-lg-12">
        <div class="common-sticky-table">
          <b-table class="datatables text-nowrap"
                   outlined show-empty
                   responsive sticky-header="500px"
                   :fields="fields" :items="items">
            <template #cell(chargeCnt)="data">
              {{ $_utils.comma(data.item.chargeCnt) }}
            </template>
            <template #cell(totEnergy)="data">
              {{ $_utils.comma(data.item.totEnergy) }}
            </template>
            <template #cell(totCost)="data">
              {{ $_utils.comma(data.item.totCost) }}
            </template>
            <template #cell(reservedCnt)="data">
              {{ $_utils.comma(data.item.reservedCnt) }}
            </template>
            <template #cell(incentivePrice)="data">
              {{ $_utils.comma(data.item.incentivePrice) }}
            </template>
          </b-table>
        </div>
      </div>
    </div>

    <template #modal-footer>
      <div class="w-100">
        <b-button variant="secondary" class="float-end w-xs p-1" @click="show=false">닫기</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import cardTitle from "@/views/components/cardTitle.vue";
import { http } from "@/mdk/auth-api";

export default {
  name: 'UserChargingHistoryModal',
  components: { cardTitle },
  props: {
    searchArgs: Object
  },
  data() {
    return {
      show: false,
      fields: [
        { key: 'placeName', label: '충전소' },
        { key: 'csoEvseNum', label: '충전기' },
        { key: 'chargeCnt', label: '충전 건수', sortable: true },
        { key: 'totEnergy', label: '충전량', sortable: true },
        { key: 'totCost', label: '충전 요금', sortable: true },
        { key: 'reservedCnt', label: '예약 충전', sortable: true },
        { key: 'incentivePrice', label: '인센티브', sortable: true }
      ],
      items: [],
    }
  },
  watch: {
    searchArgs: {
      deep: true,
      handler: 'getHistoryItems'
    },
  },
  methods: {
    async getHistoryItems() {
      const vm = this;
      const _url = `/onmapi/stats/user-used/history`;
      const targetMonth = vm.searchArgs.month;
      const userId = vm.searchArgs.userId;

      try {
        const res = await http.get(_url, {
          params: { targetMonth, userId }
        });

        vm.items = [ ...res.data.items ];

      } catch (err) {
        //this.$swal('충전 이력 조회 실패', '', 'error');
        console.error(err);
      }
    },
  }
}
</script>